<template lang="html">
  <div>
    <b-modal ref="modal-reset-password" centered hide-footer no-close-on-backdrop no-close-on-esc modal-class="modal-user-access-layout" @hide="$parent.openedModal = null;" title="Recuperar tu contraseña">
      <div class="box-sm-title">
        <h6><span>Ingresa tu email</span></h6>
      </div>

      <div class="box-account-types">
        <div class="col-12 col-type col-user no-btn">
          <div class="box">
            <div>
              <h5>Usuario o Empleador</h5>
              <h6>Recupera tu contraseña</h6>
            </div>
          </div>
        </div>
      </div>

      <p class="my-2">
        Te enviaremos un mensaje a tu correo con los pasos para recuperar el acceso tu cuenta.
      </p>

      <div class="box-form">
        <b-form @submit="onSubmitResetPass">
          <div class="row">

            <div class="col-12 col-input">
              <b-form-group
                label="Correo electrónico*"
                label-for="il-1">
                <b-form-input
                  id="il-1"
                  size="sm"
                  v-model="formResetPass.email"
                  type="text"
                  required
                ></b-form-input>
              </b-form-group>
            </div>

            <div class="col-12 col-bottom">
              <div class="row align-items-center">
                <div class="col-sm-7 col-btn">
                  <b-button type="submit" class="btn-cur-1 lg">Recuperar contraseña</b-button>
                </div>

                <div class="col-sm-5 col-links">
                  <a @click="toggleModal()">¿Ya tienes una cuenta?</a>
                </div>
              </div>
            </div>

          </div>
        </b-form>
      </div>
    </b-modal>
    <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal :icon="modal.icon" ref="modalAlert">
          {{modal.msg}}
    </sweet-modal>

  </div>
</template>

<script>
export default {
  data(){
    return{
      formResetPass: {
        email: null
      },
      modal:{
          icon:null,
          msg:null
        },
    }
  },

  methods: {
    toggleModal(){
      this.$refs['modal-reset-password'].hide();
      setTimeout( ()=>{ this.$parent.openedModal = 'login'; }, 200);
    },

    onSubmitResetPass(event) {
         event.preventDefault();
        this.$refs.modalLoading.open();
        axios.post(tools.url("/resetPasword"),this.formResetPass).then((response)=>{
            this.$refs.modalLoading.close();
            this.modal.icon = 'success';
            this.modal.msg = 'Se ha enviado a tu correo una contraseña temporal para que puedas acceder';
            this.$refs.modalAlert.open();
        }).catch((error)=>{
            console.log(error.response);
            this.$refs.modalLoading.close();
            this.modal.icon = 'error';
            this.modal.msg = error.response.data.msg;
            this.$refs.modalAlert.open();
        });
    },
  },

  watch: {
    '$parent.openedModal': function (val, oldVal) {
      if(val == 'resetPass'){
        this.$refs['modal-reset-password'].show();
      }
    }
  },

  mounted(){
    // this.$refs['modal-reset-password'].show();
  }
}
</script>
